import { values } from './enums'

const _enum = {
  Bank: 1,
  Company: 2
}

export const institutionTypes = {
  enumName: 'InstitutionTypes',
  enum: _enum,
  values: values(_enum)
}



// WEBPACK FOOTER //
// ./src/enums/institutionTypes.js